import { IndividualConfig } from 'ngx-toastr';
import { BodyComponent } from './body/body.component';

type ToastConfig = Partial<IndividualConfig>;

const baseConfig: ToastConfig = {
  toastComponent: BodyComponent,
  closeButton: true,
  timeOut: 5000,
  tapToDismiss: true,
};

export const publishedToast = (type: string = 'item'): ToastConfig => ({
  ...baseConfig,
  payload: { text: `This ${type} has been published successfully!` },
});

export const unpublishedToast = (type: string = 'item'): ToastConfig => ({
  ...baseConfig,
  payload: { text: `This ${type} has been unpublished successfully!` },
});

export const exportedToast = (count: number, type: string): ToastConfig => {
  const itemName = type === 'PIES' ? 'item' : 'fitment';
  const itemsText = (count === 1) ? `${itemName} has` : `${itemName}s have`;
  return {
    ...baseConfig,
    payload: {
      text: `${count} ${itemsText} been exported successfully!`,
      showManageExportsButton: true,
    },
  };
};

export const itemWasUpdatedToast = (user: any): ToastConfig => ({
  ...baseConfig,
  payload: {
    text: 'Updates to this item…',
    showReloadButton: true,
    user,
  },
});

export const processEndedToast = (title: string): ToastConfig => ({
  ...baseConfig,
  payload: {
    text: `${title} have completed!`,
    showReloadButton: true,
  },
});

export const rollbackToast = (): ToastConfig => ({
  ...baseConfig,
  payload: { text: 'Action has rolled back!' },
});

export const publishedMarketingCopyToast = (): ToastConfig => ({
  ...baseConfig,
  payload: { text: 'Marketing Copy has been published successfully!' },
});

export const invoiceSentToast = (): ToastConfig => ({
  ...baseConfig,
  payload: { text: 'Invoice has been sent successfully!' },
});

export const processingCompleteToast = (): ToastConfig => ({
  ...baseConfig,
  payload: { text: 'Processing is complete!' },
});

export const exportScheduledSuccessfullyToast = (): ToastConfig => ({
  ...baseConfig,
  payload: { text: 'Export scheduled successfully!' },
});
